import React, { useState, useEffect } from 'react';
import { Popover, Popconfirm, Typography, Flex, Image, Divider, App } from 'antd';
import AddBankDetails from './AddBankDetails';
import CustomButton from '../../../components/CustomButton/Button';
import { useDispatch, useSelector } from "react-redux";
import { getBankDetailsByOrgId, removeBank, makeBankPrimary } from '../../../redux/slices/ProfileSlice';
import NoData from "../../../components/NoData/NoData";
import VerifiedIcon from '../../../assets/icons/verified-icon.svg';
import MoreIcon from "../../../assets/icons/more-icon.svg";
import EditIcon from "../../../assets/icons/edit-icon.svg";
import TrashIcon from "../../../assets/icons/trash.svg";
import Loader from "../../../components/CustomLoader/Loader"
import { capitalizeEntireWord } from '../../../helpers/helpers';
import { BTN_TXT, DESC_TXT, GLOBAL_CONSTANTS, TITLE_TXT } from '../../../constants/constants';
import ProfileDetail from '../../../components/Details/ProfileDetail';

const { Text, Title } = Typography;


const BankDetails = () => {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [isAddNewBank, setIsAddNewBank] = useState(false);
  const [popoverVisible, setPopoverVisible] = useState({});
  const { bankDetailsData, loading, error } = useSelector((state) => state.profile);
  const { notification } = App.useApp();


  useEffect(() => {
    dispatch(getBankDetailsByOrgId(user?.orgId));
  }, [dispatch, user.orgId]);

  useEffect(() => {
    if (error) {
      notification.error({
        message: 'Error',
        description: error,
        placement: 'topRight',
        duration: 3,
      });
    }
  }, [error, notification]);

  const handleDelete = async (accNum) => {
    const payload = { accNum }
    const res = await dispatch(removeBank(payload))

    if (res.payload.statusCode === 201) {
      dispatch(getBankDetailsByOrgId(user?.orgId));
      setPopoverVisible({});
    }

  };

  const handleMarkAsPrimary = async (accNum) => {
    const payload = { accNum }
    const res = await dispatch(makeBankPrimary(payload))

    if (res.payload.statusCode === 201) {
      dispatch(getBankDetailsByOrgId(user?.orgId));
      setPopoverVisible({});
    }
  };

  const popoverContent = (bank) => (
    <div>
      <Popconfirm
        title={GLOBAL_CONSTANTS.DEL_BANK_CONFIRM}
        okText="Yes"
        cancelText="No"
        onConfirm={() => handleDelete(bank.accNum)}
        getPopupContainer={(trigger) => trigger.parentElement}
      >
        <Flex align="center" gap="small" style={{ cursor: "pointer" }}>
          <Image src={TrashIcon} alt="Delete" preview={false} />
          <Text>{GLOBAL_CONSTANTS.DEL}</Text>
        </Flex>
      </Popconfirm>
      <Divider style={{ margin: "10px 0" }} />
      <Flex align="center" gap="small" onClick={() => handleMarkAsPrimary(bank.accNum)} style={{ cursor: "pointer" }}>
        <Image src={EditIcon} alt="Mark as Primary" preview={false} />
        <Text>{GLOBAL_CONSTANTS.MARK_AS_PRI}</Text>
      </Flex>
    </div>
  );

  const sortedBankDetails = [...(bankDetailsData || [])]
    .sort((a, b) => Number(Boolean(b.isPrimary)) - Number(Boolean(a.isPrimary)));

  const bankDetails = (
    <div className='investor-details-container'>
      <div className='header-container'>
        <Flex align="center" justify='space-between'>
          <Title level={4}>{TITLE_TXT.BANK_DETS}</Title>
          {sortedBankDetails.length > 0 && sortedBankDetails.length < 2 && <CustomButton type="primary" onClick={() => setIsAddNewBank(true)}>{BTN_TXT.ADD_NEW_BANK}</CustomButton>}
        </Flex>
      </div>
      {sortedBankDetails.length > 0 ? (
        sortedBankDetails.map(bank => (
          <div key={bank.bankId} className='bank-details-container'>
            <Flex align='center' justify='space-between' style={{ marginBottom: 30 }}>
              <Flex gap={10} align='center' wrap>
                {/* <Image src={bank.bankLogo} alt='Bank Logo' preview={false} /> */}
                <Text strong>{capitalizeEntireWord(bank.bankName)}</Text>
                {bank.isVerified && <img src={VerifiedIcon} alt='Verified' />}
                {bank.isPrimary && <div className='primary-bank-tag'>{GLOBAL_CONSTANTS.PRIM_BANK}</div>}
              </Flex>
              {!bank.isPrimary && (
                <Popover
                  content={popoverContent(bank)}
                  trigger="click"
                  arrow={false}
                  placement='bottomRight'
                  open={popoverVisible[bank.bankId]}
                  onOpenChange={(visible) => setPopoverVisible({ ...popoverVisible, [bank.bankId]: visible })}
                >
                  <Image src={MoreIcon} alt='Actions' preview={false} style={{ cursor: 'pointer' }} />
                </Popover>
              )}
            </Flex>

            <ProfileDetail
              label={GLOBAL_CONSTANTS.ACC_NUM}
              value={bank?.accNum}
            />

            <ProfileDetail
              label={GLOBAL_CONSTANTS.ACC_HOL_NAME}
              value={bank?.accHolderName}
            />

            <ProfileDetail
              label={GLOBAL_CONSTANTS.ACC_IFSC}
              value={bank?.ifscCode}
            />

            <ProfileDetail
              label={GLOBAL_CONSTANTS.BRA_NAME}
              value={capitalizeEntireWord(bank?.branchName)}
            />

          </div>
        ))
      ) : (
        <div className='no-data-container'>
          <NoData desc={DESC_TXT.BANK_DETS_NOT_AVAIL} />
        </div>
      )}
    </div>
  );

  return (
    <>
      {isAddNewBank ? <AddBankDetails goBack={() => setIsAddNewBank(false)} /> : loading ? <Loader /> : bankDetails}
    </>
  );
};

export default BankDetails;
